import React, {useEffect, useReducer} from 'react';
import {ContentAdDesktop} from 'app/styles/content';
import StreamContainer from 'app/components/stream/streamContainer';
import {playerFilters} from 'app/components/stream/streamFilter.const';
import {Helmet} from 'react-helmet-async';
import {string} from 'prop-types';
import {overwriteNews, fetchPlayerNews} from 'app/routes/player/PlayerPageActions';
import {useInfiniteScrollComponentState} from 'app/hooks/useInfiniteScroll';
import {StreamFilterFab} from 'app/components/floatingAction/StreamFilterFab';
import {useFetchData, useRestoreData} from 'app/hooks/dataHooks';
import {useParams} from 'react-router';
import {PlayerNewsPageReducer} from 'app/routes/player/PlayerPageReducer';

const streamRegex = /\/player\/[a-z0-9-]+\/news\//;

const PlayerNewsPage = ({metaDescription, dispatchRedux}) => {
  const topValue = '0rem';
  const {restoredData} = useRestoreData('PlayerNewsPage');
  const {playerSlug, categories} = useParams();
  const initialData = {
    isFetching: false,
    items: [],
    nextUrl: '',
    categoryFilter: categories,
    error: null,
  };
  const initialState = restoredData ?? initialData;
  const [state, dispatch] = useReducer(PlayerNewsPageReducer, initialState);

  const loadData = (reloading, reset) => {
    const componentState = reset ? initialData : state;
    return fetchPlayerNews(playerSlug, categories, reloading, dispatchRedux)(dispatch, componentState);
  };

  const {items, isFetching, nextUrl, error, categoryFilter} = state;
  const filter = playerFilters.find(filter => filter.param === categories);
  const title = filter ? `${filter.value} - ` : 'News - ';
  const meta = [
    {name: 'description', content: title + metaDescription},
    {name: 'robots', content: 'noindex, follow'},
  ];
  useInfiniteScrollComponentState(loadData, items.length);
  useFetchData(state, loadData, 'PlayerNewsPage', true);

  useEffect(() => {
    // Always load new data when switching between filters
    if (categoryFilter !== categories) {
      dispatch(overwriteNews(initialData));
      loadData(false, true);
    }
  }, [categories]);

  return (
    <ContentAdDesktop
      bgColor='none'
      top={topValue}
      fabBtn={<StreamFilterFab filter={playerFilters} regex={streamRegex} />}>
      <Helmet title={title} meta={meta} />
      <StreamContainer isFetching={isFetching} error={Boolean(error)} nextPage={nextUrl} stream={items} />
    </ContentAdDesktop>
  );
};

PlayerNewsPage.propTypes = {
  metaDescription: string.isRequired,
};

export default PlayerNewsPage;
